<template>
  <div>
    <h2>
      Total Weight:
      <span v-if="quantity > 0 && pieceWeightImperial > 0">
        <strong>
          {{ `${formatWeight(totalWeightImperial)} lbs` }}
        </strong>
        &mdash;
        <strong>
          {{ `${formatWeight(totalWeightMetric)} kg` }}
        </strong>
      </span>
    </h2>

    <h2>
      Piece Weight:
      <span v-if="pieceWeightImperial > 0">
        <strong>
          {{ `${formatWeight(pieceWeightImperial)} lbs` }}
        </strong>
        &mdash;
        <strong>
          {{ `${formatWeight(pieceWeightMetric)} kg` }}
        </strong>
      </span>
    </h2>
  </div>
</template>

<script>
export default {
  props: {
    productType: {
      type: String,
      default: null
    },
    density: {
      type: Number,
      default: 0
    },
    dimensions: {
      type: Object,
      default: null
    },
    quantity: {
      type: Number,
      default: 1
    }
  },
  computed: {
    pieceWeightImperial() {
      let result;

      switch (this.productType) {
        case "round":
          result =
            (((Math.PI *
              this.density *
              (this.dimensions.diameter.inches +
                this.dimensions.diameter.tolerance) **
                2 *
              12) /
              4) *
              this.dimensions.length.inches) /
            12;
          break;
        case "hex":
          result =
            (12 *
              (this.dimensions.acrossFlats.inches +
                this.dimensions.acrossFlats.tolerance) **
                2 *
              (Math.sqrt(3) * 0.5) *
              this.density *
              this.dimensions.length.inches) /
            12;
          break;
        case "flat":
          result =
            (this.density *
              (this.dimensions.thickness.inches +
                this.dimensions.thickness.tolerance) *
              (this.dimensions.width.inches + this.dimensions.width.tolerance) *
              12 *
              this.dimensions.length.inches) /
            12;
          break;
        case "hollow":
          result =
            (((37.7 *
              this.density *
              ((this.dimensions.outsideDiameter.inches +
                this.dimensions.outsideDiameter.tolerance) **
                2 -
                (this.dimensions.insideDiameter.inches +
                  this.dimensions.insideDiameter.tolerance) **
                  2)) /
              4) *
              this.dimensions.length.inches) /
            12;
          break;
        case "tube":
          result =
            (37.7 *
              this.density *
              (this.dimensions.outsideDiameter.inches +
                this.dimensions.outsideDiameter.tolerance -
                this.dimensions.wallThickness.inches *
                  this.dimensions.wallThickness.tolerance) *
              (this.dimensions.wallThickness.inches *
                this.dimensions.wallThickness.tolerance) *
              this.dimensions.length.inches) /
            12;
          break;
        default:
          result = 0;
          break;
      }

      return result;
    },
    pieceWeightMetric() {
      return this.pieceWeightImperial * 0.45359237;
    },
    totalWeightImperial() {
      return this.pieceWeightImperial * this.quantity;
    },
    totalWeightMetric() {
      return this.pieceWeightMetric * this.quantity;
    }
  },
  methods: {
    formatWeight(weight) {
      return new Intl.NumberFormat("en-US", {
        maximumSignificantDigits: 4
      }).format(weight);
    }
  }
};
</script>
